__turbopack_context__.v({
  "cardBackground": "heroCarouselCard-module-scss-module__pADGzq__cardBackground",
  "cardContent": "heroCarouselCard-module-scss-module__pADGzq__cardContent",
  "cardOverlay": "heroCarouselCard-module-scss-module__pADGzq__cardOverlay",
  "carouselCard": "heroCarouselCard-module-scss-module__pADGzq__carouselCard",
  "ctaAndMailWrapper": "heroCarouselCard-module-scss-module__pADGzq__ctaAndMailWrapper",
  "headline": "heroCarouselCard-module-scss-module__pADGzq__headline",
  "headlineRow": "heroCarouselCard-module-scss-module__pADGzq__headlineRow",
  "mailOfferWrapper": "heroCarouselCard-module-scss-module__pADGzq__mailOfferWrapper",
  "promotion": "heroCarouselCard-module-scss-module__pADGzq__promotion",
  "promotionFirstLine": "heroCarouselCard-module-scss-module__pADGzq__promotionFirstLine",
  "promotionRow": "heroCarouselCard-module-scss-module__pADGzq__promotionRow",
  "promotionWrapper": "heroCarouselCard-module-scss-module__pADGzq__promotionWrapper",
});
